import { createFormViewContainer } from 'factories/FormView'
import { createDocumentsDispatchToProps } from 'helpers/formViews'
import actions from 'actions/inventory'
import assetsActions from 'actions/assets'
import supplierActions from 'actions/suppliers'
import locationActions from 'actions/locations'
import productActions from 'actions/products'
import documentActions from 'actions/documents'
import Component from 'components/Inventory/FormView'

export default createFormViewContainer({
  actions,
  extraDispatchToProps: (dispatch, props) => ({
    generateAssetId: (params) => dispatch(assetsActions.generateId(params)),
    getLocations: (params) =>
      dispatch(locationActions.getItems({ ...params, locationVendingTypes: ['NonVending'] })),
    getSuppliers: (params) =>
      dispatch(
        supplierActions.getOptions({
          pageIndex: 1,
          pageSize: 100,
          ...params,
          active: 'Active',
        })
      ),
    copyToPrivate: (params) => dispatch(productActions.copyToPrivate(params)),
    ...createDocumentsDispatchToProps(dispatch, documentActions),
  }),
})(Component)
